import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=286ba720"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"
import style0 from "./Credits.vue?vue&type=style&index=0&id=286ba720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports